// import one from '../assets/jpg/landingPage.jpg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    
    {
        id: 2,
        projectName: 'HOTEL BOOKING APP',
        projectDesc: 'It is a web application to book hotels.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/webdeveshverma/Marriott_Bonvoy_clone.github.io',
        demo: 'https://personal-iota-flame.vercel.app/',
        image: 'https://i.ibb.co/HrWfTyr/Marriott.png'
    },
    {
        id: 3,
        projectName: 'CGPA-CALCULATOR',
        projectDesc: 'It is use for basically college and university CGPA calculation per semester wise',
        tags: ['HTML','CSS','JAVASCRIPT'],
        code: 'https://github.com/AVIJITGHOSH2001/CGPA-calculator-',
        demo: '',
        image: 'https://websitecmscdn.s3.ap-south-1.amazonaws.com/converting_gpa_to_percentage_cee137e6ae.webp?updated_at=2023-04-17T08:00:55.753ZJzyWQ/AGODA-CLONE.jpg'
    },
   {
        id: 4,
        projectName: 'Covid vaccine Schedular online System',
        projectDesc: 'It is use for booking covid vacine is avalable or not near by hospital',
        tags: ['HTML','CSS','PHP','MYSQL'],
        code: 'https://github.com/AVIJITGHOSH2001/covid-vaccine-schedular-system',
        demo: '',
        image: 'https://bmcri.org/wp-content/uploads/2022/01/Cowin.gov_.in-Vaccine-Online-Self-Registration-2022-Slot-Booking-1024x536.webp'
    },
    {
        id: 5,
        projectName: 'RegistrationLoin page',
        projectDesc: 'It is like a login and registration page using whith apache Tomcat server and data base are connected with mySql',
        tags: ['HTML', 'JAVA','MYSQL','ECLIPSE'],
        code: 'https://github.com/AVIJITGHOSH2001/jdbc_connection_avijit1',
        demo: '',
        image: 'https://i.ytimg.com/vi/AWa5YlbRUhM/sddefault.jpg'
    },
    {
        id: 6,
        projectName: 'KIDNEY DISEASE PREDICTION WITH IOMT DEVICE',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['PYTHON', 'PANDAS', 'ML', 'Django'],
        code: 'https://github.com/AVIJITGHOSH2001/kidney-disease-prediction-manegment-system-with-machine-learning-and-IOMT',
        demo: '',
        image: 'https://media.springernature.com/lw685/springer-static/image/art%3A10.1007%2Fs11227-023-05337-6/MediaObjects/11227_2023_5337_Fig1_HTML.png'
    },
    {
        id: 7,
        projectName: 'COMING SOON',
        projectDesc: 'COMING SOON',
        tags: ['COMING SOON'],
        code: 'COMING SOON',
        demo: '',
        image: ''
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
